import { render, staticRenderFns } from "./ElettrostimolatoreEdit.vue?vue&type=template&id=18b6b291&scoped=true"
import script from "./ElettrostimolatoreEdit.vue?vue&type=script&lang=js"
export * from "./ElettrostimolatoreEdit.vue?vue&type=script&lang=js"
import style0 from "./ElettrostimolatoreEdit.vue?vue&type=style&index=0&id=18b6b291&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b6b291",
  null
  
)

export default component.exports